import { BoxTitle } from '@/components/BoxTitle';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { Paper } from '@/components/Paper';
import CustomButton from '@/components/UI/Button';
import ModalRetorno from '@/modules/Portaria/components/ModalRetorno';
import { Flex, Grid, HStack, Progress, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { useServicePermission } from '../servicePermitions';

export const ClonePermittion = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [mensagemErro, setMensagemErro] = useState<string | null>(null);
  const [mensagemSucesso, setMensagemSucesso] = useState<string | null>(null);
  const nav = useNavigate();

  const {
    isCloning,
    listUsuario,
    userToReceived,
    setClonerSelected,
    clonerSelected,
    setUserToReceived,
    submitClonagem,
  } = useServicePermission();

  const receiverValue = useMemo(
    () => listUsuario?.find((u: any) => u.value === userToReceived) ?? null,
    [listUsuario, userToReceived],
  );

  const clonerValue = useMemo(
    () => listUsuario?.find((u: any) => u.value === clonerSelected) ?? null,
    [listUsuario, clonerSelected],
  );

  const handleClose = () => {
    nav(-1)
    setIsOpen(false);
  };

  const handleSubmit = async () => {
    await submitClonagem();
    nav(-1)
  };

  const body = (
    <Paper w="full" bg="white" shadow="sm" py={4} rounded="xl">
      <Grid gap={2}>
        <HStack w={'100%'}>

          <BoxTitle title='Clonar de:'>
            <Select
              aria-label="Selecionador-Usuário"
              value={clonerValue}
              onChange={(e) => {
                //@ts-ignore
                setClonerSelected(e?.value);
              }}
              options={listUsuario}
              styles={{
                control: (base) => ({
                  ...base,
                  width: '100%',
                  minWidth: '250px'
                }),
              }}
            />
          </BoxTitle>

          <BoxTitle title='Para:'>
            <Select
              aria-label="Selecionador-Usuário"
              value={receiverValue}
              onChange={(e) => {
                //@ts-ignore
                setUserToReceived(e?.value);
              }}
              options={listUsuario}
              styles={{
                control: (base) => ({
                  ...base,
                  width: '100%',
                  minWidth: '280px'
                }),
              }}
            />
          </BoxTitle>
        </HStack>

      </Grid>
      <HStack >
        <motion.div
          animate={{
            width: isCloning ? '190px' : '0px',
            visibility: isCloning ? 'visible' : 'hidden',
          }}
        >
          <Progress w={'100%'} size="xs" isIndeterminate />
        </motion.div>
      </HStack>
    </Paper>
  );

  return (
    <>
      <ModalAlert
        title={
          <VStack align="center">
            <Text fontSize="xl" fontWeight={'bold'}>
              Clonar Permissões
            </Text>
          </VStack>

        }
        isOpen={isOpen}
        body={body}
        size="xl"
        bg="#117baa"
        xIsback
        footer={<>
          <Flex p={0} justifyContent="center" gap={2}>
            <CustomButton
              label="Cancelar"
              variant="danger"
              size="md"
              onClick={handleClose}
              disabled={isCloning}
            />

            <CustomButton
              label="Clonar"
              variant="primary"
              size="md"
              onClick={handleSubmit}
              loading={isCloning}
            />
          </Flex>
        </>
        }
      />

      {(mensagemErro || mensagemSucesso) && (
        <ModalRetorno
          isOpen={true}
          onClose={() => {
            setMensagemErro(null);
            setMensagemSucesso(null);
          }}
          mensagem={mensagemErro || mensagemSucesso || ''}
          tipo={mensagemErro ? 'erro' : 'sucesso'}
        />
      )}
    </>
  );
};
